
import { Component, Vue } from "vue-property-decorator";
import BodyElementComponent from "./tiles/body-element.vue";
import { LayoutInterface } from "../store/config.types";

@Component({
  components: {
    "body-element": BodyElementComponent,
  },
})
export default class BodyComponent extends Vue {
  get layout(): LayoutInterface {
    return this.$store.getters["config/getLayout"](this.$store.getters["config/getActiveLayoutIndex"]())
  }

  get tileConfig() {
    return this.$store.getters.configureTile;
  }

  get tiles() {
    return this.layout.config;
  }
}
